<div class="flex-column gap p-1">
    @if (isMedicalOrganization()) {
        <app-user-role-medical-service #servicesRoles></app-user-role-medical-service>
    } @else {
        <div class="flex flex-column gap">
            <div class="w-full flex justify-content-end">
                @if (store.isAllowedGlobal('rule.update')()) {
                    <!--                <app-button-->
                        <!--                    [label]="'user.fields.groups' | translate"-->
                        <!--                    [text]="true"-->
                        <!--                    (clickEvent)="editGroups()"-->
                        <!--                ></app-button>-->
                }
            </div>

            <app-select-user-group
                [form]="form"
                [disabled]="!store.isAllowed('user.update')()"
            ></app-select-user-group>
            <app-select-user-rule
                [form]="form"
                [disabled]="!store.isAllowed('user.update')()"
            ></app-select-user-rule>
        </div>
    }

    @if (store.isAllowed('user.update')() && store.isAllowedGlobal('organization.update')()) {
        <p-message severity="error">
            <ng-template #container>
                <div class="flex flex-column gap w-full">
                    <div>{{ 'user.editUser.labels.globalRolesAndRules' | translate }}</div>
                    <app-select-user-group
                        id="globalGroupIds"
                        [showLabel]="false"
                        [form]="globalForm"
                        [globalAcl]="true"
                        [disabled]="!store.isAllowed('user.update')()"
                    ></app-select-user-group>
                    <!--        Tohle nefunguje - role to teď ukladá pod organizationId-->
                    <!--        <app-select-user-rule-->
                    <!--            [form]="globalForm"-->
                    <!--            [globalAcl]="true"-->
                    <!--            [disabled]="!store.isAllowed('user.update')()"-->
                    <!--        ></app-select-user-rule>-->
                </div>
            </ng-template>
        </p-message>
    }
</div>
